let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lW4Du")).then(() => parcelRequire('1J3S4'));